import { render } from "./IntegrityBlockView.vue?vue&type=template&id=8cfc6658&scoped=true"
import script from "./IntegrityBlockView.vue?vue&type=script&lang=js"
export * from "./IntegrityBlockView.vue?vue&type=script&lang=js"

import "./IntegrityBlockView.vue?vue&type=style&index=0&id=8cfc6658&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cfc6658"]])

export default __exports__